import stockCountEntry from '@/api/stock-count-entry'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  products: [],
  branch_id: null
}

export const getters = {
  productNotIncludeSelected:
    state =>
    ({ addedProducts, excludeProductId } = {}) => {
      if (addedProducts !== undefined && excludeProductId !== undefined) {
        return state.products.filter(
          p =>
            !_.includes(
              addedProducts
                .filter(t => t.product_id != excludeProductId)
                .map(t => t.product_id),
              p.product_id
            )
        )
      }

      return state.products
    }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  },
  SET_PRODUCT (state, data) {
    state.products = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return stockCountEntry.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store (context, data) {
    return stockCountEntry.store(data)
  },

  update (context, data) {
    return stockCountEntry.update(data)
  },
  destroy (context, id) {
    return stockCountEntry.destroy(id)
  },

  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stockCountEntry.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getSystemQty (context, product_id) {
    return await stockCountEntry.getSystemQty(product_id)
  },
  async dataBeforeCreate (context) {
    if (!context.state.products.length > 0) {
      let response = await stockCountEntry.getProduct()
      context.commit('SET_PRODUCT', response.data)
    }
  }
}
